// Libraries
import { Flex, Text } from '@chakra-ui/react';
// Components
import { Spinner, UploadFileIcon } from '@atoms/index';
// Utils
import text from '@translations/en.json';
// Types
import { FileUploadProps, FileUploadStatus } from './FileUpload.types';

/**
 * FileUpload component for handling file uploads.
 * @component
 *
 * @param {FileUploadProps} props - The component props.
 * @param {string} props.customerId - The ID of the customer.
 * @param {Vessel[]} props.vessels - The array of vessels.
 * @returns {ReactElement} The FileUpload component.
 */
export const FileUpload = ({ isDisabled, status }: FileUploadProps) => {
  return (
    <Flex w={80} direction='column' alignItems='center' rowGap={7}>
      {isDisabled ||
        (status === FileUploadStatus.EMPTY && (
          <Flex minH={40} direction='column' alignItems='center' rowGap={7}>
            <UploadFileIcon boxSize={14} />
            <Text fontSize='l' fontWeight='m' variant='faded'>
              {text.drag_drop_vessel_schedule_file}
            </Text>
            <Text fontSize='l' fontWeight='m' variant='faded'>
              {text.or}
            </Text>
          </Flex>
        ))}
      <Flex flexDir='column' alignItems='center' rowGap={5}>
        {(status === FileUploadStatus.LOADING || isDisabled) && <Spinner color='base' size='xl' minH={40} />}
        {status === FileUploadStatus.LOADING && !isDisabled && <Text variant='darkLabel'>{text.loading}</Text>}
        {isDisabled && <Text variant='darkLabel'>{text.processing_file}</Text>}
      </Flex>
    </Flex>
  );
};
